export const POSTHOG_EVENTS = {
    SCAN_UPLOAD_FAILED: 'scan.upload.failed',
    SCAN_CONTINUED_TO_BATCH: 'scan.continued_to_batch',
    TEMPLATE_TITLE_CREATED: 'template.title.created',
    TEMPLATE_TITLE_UPDATED: 'template.title.updated',
    TEMPLATE_DESCRIPTION_CREATED: 'template.description.created',
    TEMPLATE_DESCRIPTION_UPDATED: 'template.description.updated',
    EXPORT_LISTINGS_SUCCEEDED: 'export.listings.succeeded',
    ONBOARDING_STEP_WELCOME_VIEWED: 'onboarding.step_welcome.viewed',
    ONBOARDING_STEP_WELCOME_COMPLETED: 'onboarding.step_welcome.completed',
    ONBOARDING_STEP_ABOUT_MARKETPLACES_COMPLETED: 'onboarding.step_aboutMarketplaces.completed',
    ONBOARDING_STEP_ABOUT_YOURSELF_COMPLETED: 'onboarding.step_aboutYourself.completed',
    ONBOARDING_STEP_ORG_DETAILS_COMPLETED: 'onboarding.step_orgDetails.completed',
    ONBOARDING_STEP_PLAN_COMPLETED: 'onboarding.step_plan.completed',
    ONBOARDING_COMPLETED: 'onboarding.completed',
    COACHING_GETTING_STARTED_COMPLETED: 'coaching.getting_started.completed',
    CONNECTION_ADDED: 'connection.added',
    CARD_MARKET_PRICE_ADDED: 'card.marketprice.added',
    SUBSCRIPTION_UPGRADE_INITIATED: 'subscription_upgrade_initiated',
    SUBSCRIPTION_DOWNGRADE_INITIATED: 'subscription_downgrade_initiated',
    PAYWALL_VIEWED: 'paywall_viewed',
    USER_CREATE_ACCOUNT_VIEW: 'user_createAccount_view',
    USER_CREATE_ACCOUNT_SUBMITTED: 'user_createAccount_submitted',
    // Inventory redesign experiment (`inventory-beta`). PostHog stamps every
    // event with the user's variant, so these two are what the experiment's
    // opt-in / opt-out funnel is measured on.
    INVENTORY_BETA_OPTED_IN: 'inventory_beta.opted_in',
    INVENTORY_BETA_OPTED_OUT: 'inventory_beta.opted_out',
}